<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">Cam kết bảo mật</p>

        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>

  </div>
</template>

<script>
// import importedImg1 from "@/page/hatacocompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: 'protocolTitle',
      // importedImg1: importedImg1,
      text: `Chính sách bảo mật này giải thích cách CÔNG TY TNHH DỊCH VỤ KỸ THUẬT CÔNG NGHỆ NCK LỘC PHÁT (sau đây gọi là “Công ty chúng tôi”) thu thập, sử dụng, lưu trữ và bảo vệ thông tin cá nhân của bạn. Vui lòng đọc kỹ chính sách này trước khi sử dụng trang web (sau đây gọi là "Trang web") hoặc dịch vụ của chúng tôi.

1. Thông tin chúng tôi thu thập
Khi bạn truy cập trang web hoặc sử dụng dịch vụ của chúng tôi, chúng tôi có thể thu thập các thông tin sau:

1.1 Thông tin cá nhân
Họ và tên, số điện thoại, địa chỉ email;
Địa chỉ giao hàng, địa chỉ thanh toán;
Thông tin thanh toán (chẳng hạn như số tài khoản ngân hàng, phương thức thanh toán, v.v.);
Các thông tin khác bạn cung cấp khi đăng ký tài khoản.
1.2 Thông tin thiết bị và kỹ thuật
Địa chỉ IP, loại trình duyệt, hệ điều hành;
Thời gian truy cập, nhật ký nhấp chuột, lịch sử duyệt trang;
Mã định danh thiết bị, cookie và các công nghệ tương tự.
1.3 Thông tin giao dịch
Hồ sơ mua hàng của bạn;
Mã đơn hàng, thông tin hóa đơn;
Lịch sử dịch vụ hậu mãi và sửa chữa.

2. Cách chúng tôi sử dụng thông tin của bạn
Thông tin thu thập được sẽ được sử dụng cho các mục đích sau:

Xử lý đơn hàng, cung cấp dịch vụ giao hàng, sửa chữa, hậu mãi;
Duy trì thông tin tài khoản và cung cấp dịch vụ cá nhân hóa;
Hỗ trợ khách hàng, xử lý khiếu nại và phản hồi của bạn;
Phân tích thị trường, cải thiện sản phẩm và dịch vụ;
Gửi thông tin khuyến mãi, ưu đãi đặc biệt (nếu bạn đồng ý);
Tuân thủ các quy định của pháp luật, phòng chống gian lận và hành vi vi phạm.

3. Chia sẻ và tiết lộ thông tin
Chúng tôi không bán, cho thuê hoặc chia sẻ thông tin cá nhân của bạn với bất kỳ bên thứ ba nào không liên quan, trừ các trường hợp sau:

Chia sẻ với đối tác dịch vụ: Chúng tôi có thể chia sẻ thông tin với các đối tác như công ty vận chuyển, nền tảng thanh toán để thực hiện đơn hàng, xử lý thanh toán và giao hàng;
Theo yêu cầu pháp lý: Nếu có yêu cầu từ cơ quan nhà nước hoặc quy định của pháp luật, chúng tôi có thể tiết lộ thông tin của bạn;
Chuyển nhượng doanh nghiệp: Trong trường hợp sáp nhập, mua lại hoặc chuyển nhượng tài sản, thông tin cá nhân của bạn có thể được chuyển giao cho bên liên quan.

4. Lưu trữ và bảo mật dữ liệu
Chúng tôi áp dụng các biện pháp kỹ thuật và quản lý thích hợp để bảo vệ thông tin cá nhân của bạn, nhằm ngăn chặn truy cập, sử dụng hoặc tiết lộ trái phép.

Chỉ những nhân viên được ủy quyền mới có quyền truy cập thông tin cá nhân;
Sử dụng mã hóa SSL để bảo vệ thông tin thanh toán trực tuyến;
Máy chủ và cơ sở dữ liệu được bảo vệ bằng tường lửa và kiểm soát truy cập.
Mặc dù chúng tôi đã thực hiện các biện pháp an ninh hợp lý, nhưng việc truyền dữ liệu qua Internet không thể đảm bảo an toàn 100%, và chúng tôi không thể đảm bảo thông tin của bạn hoàn toàn an toàn.

5. Cookie và công nghệ theo dõi
Chúng tôi sử dụng Cookie và các công nghệ tương tự để tối ưu hóa trải nghiệm người dùng. Cookie giúp chúng tôi:

Ghi nhớ trạng thái đăng nhập của bạn, giúp bạn truy cập tài khoản dễ dàng hơn;
Ghi nhận sở thích mua sắm của bạn và đề xuất sản phẩm phù hợp;
Phân tích lưu lượng truy cập để cải thiện hiệu suất trang web.
Bạn có thể tắt Cookie trong cài đặt trình duyệt của mình, nhưng điều này có thể ảnh hưởng đến một số chức năng của trang web.

6. Quyền của bạn
Theo quy định của pháp luật hiện hành, bạn có quyền:

Truy cập thông tin cá nhân của mình và yêu cầu cung cấp bản sao dữ liệu liên quan;
Chỉnh sửa thông tin nếu thông tin không chính xác hoặc chưa đầy đủ;
Yêu cầu xóa thông tin cá nhân, trong phạm vi pháp luật cho phép;
Rút lại sự đồng ý, ngừng nhận thông tin khuyến mãi hoặc email quảng cáo.
Nếu bạn muốn thực hiện các quyền trên, vui lòng liên hệ với chúng tôi theo thông tin bên dưới.

7. Bảo vệ quyền riêng tư của trẻ em
Trang web và dịch vụ của chúng tôi không dành cho trẻ em dưới 16 tuổi. Nếu phát hiện trẻ vị thành niên đã cung cấp thông tin cá nhân, chúng tôi sẽ ngay lập tức xóa bỏ dữ liệu đó.

8. Liên kết đến trang web bên thứ ba
Trang web của chúng tôi có thể chứa liên kết đến các trang web bên thứ ba. Chúng tôi không chịu trách nhiệm về chính sách bảo mật hoặc nội dung của các trang web đó. Vui lòng đọc chính sách bảo mật của họ trước khi truy cập.

9. Thay đổi chính sách bảo mật
Chúng tôi có thể cập nhật chính sách bảo mật này theo thời gian. Phiên bản mới nhất sẽ được đăng trên trang web của chúng tôi và có ghi ngày có hiệu lực. Vui lòng kiểm tra thường xuyên để cập nhật thông tin mới nhất.

10. Thông tin liên hệ
Nếu bạn có bất kỳ câu hỏi nào về chính sách bảo mật này hoặc muốn thực hiện quyền của mình, vui lòng liên hệ với chúng tôi:

Tên công ty: CÔNG TY TNHH DỊCH VỤ KỸ THUẬT CÔNG NGHỆ NCK LỘC PHÁT
Địa chỉ: 10B NGUYỂN ĐÌNH CHIỂU P1 THÀNH  PHỐ TÂN AN LONG AN 
Số điện thoại: 0562880341
Email: info@ankhangcomputer.com`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #FFFFFF;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 2000px;
  background-color: #FFFFFF;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3F4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  /* transform: scale(90%); */
  transform: scale(80%);
  margin: -250px auto 100px;
  height: 2500px;
  box-shadow: 0 4px 5.3px 2px rgba(169, 161, 161, 0.25);
  /* border: 2px solid #333333; */
}

.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}

/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0BAF60;
  margin: 0 500px;
}

.img1 {
  /* margin-top: 50px;
  padding: 0 200px 100px; */
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "SF Pro Display";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
</style>